import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'

import Routes from './routes'

ReactDOM.hydrate(
    <Routes />
, document.getElementById('root')
)





// WEBPACK FOOTER //
// ./src/index.js